<template>
  <div>
    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <p class="modal-card-title">{{$t('index.additional_fields',{tagname: tagName})}}</p>
      </header>

      <section class="modal-card-body">
        <b-table
          :data="resultFields"
          :striped="true"
          :narrowed="false"
          :mobile-cards="true"
          :paginated="false"
          :per-page="10"
          :pagination-simple="true"
          default-sort="['type', 'desc']"
        >
          <template slot-scope="props">
            <b-table-column
              field="name"
              :label="$t('index.name')"
              width="210"
            >
              <b-field
                v-if="props.row.type===1&&erroredFiedls[props.index]"
                type="is-danger"
                :message="$t('index.additional_fields_message')"
              >
                <b-input
                  @input="validateCustomType($event,props.index)"
                  v-model="props.row.name"
                ></b-input>
              </b-field>
              <b-field v-if="props.row.type===1&&!erroredFiedls[props.index]">
                <b-input
                  @input="validateCustomType($event,props.index)"
                  v-model="props.row.name"
                ></b-input>
              </b-field>
              <span v-if="props.row.type!==1">{{props.row.name}}</span>
            </b-table-column>

            <b-table-column
              :label="$t('index.default_value')"
              field="value"
              width="200"
            >

              <b-field>
                <b-input
                  v-if="props.row.value"
                  :disabled="isEditable(props.row.name)"
                  expanded
                  v-model="props.row.value"
                ></b-input>
              </b-field>

            </b-table-column>

            <b-table-column
              :label="$t('index.edit_by_customer')"
              field="edit"
              width="40"
              centered
            >
              <b-checkbox
                type="is-info"
                v-model="props.row.edit"
                :disabled="props.row.type!==1"
              ></b-checkbox>
            </b-table-column>
            <b-table-column
              field="tools"
              label=""
              width="40"
              centered
            >
              <button
                @click="deleteField(props.row)"
                class="button is-danger"
                type="button"
              >{{$t('index.delete')}}</button>
            </b-table-column>
          </template>
        </b-table>

        <br>
        <div class="buttons has-addons is-centered">
          <button
            @click="showAvailableFields"
            class="button is-info"
            type="button"
          >{{$t('index.add_field')}}</button>
        </div>
      </section>

      <footer class="modal-card-foot  columns is-gapless">
        <div class="column is-half">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >{{$t('index.close')}}</button>
        </div>
        <div class="column is-half has-text-right">
          <button
            v-if="!validateCustomFieldError"
            class="button is-info "
            @click="saveFileds"
          >{{$t('index.save_and_close')}}</button>
        </div>

      </footer>
    </div>

    <b-modal
      :active.sync="isShowAvailableFields"
      has-modal-card
    >
      <div
        class="modal-card"
        style="width: auto;min-width:300px"
      >
        <header class="modal-card-head">
          <span class="modal-card-title">{{$t('index.select_fields')}}

          </span>
          <span
            v-if="checkedAvailableFields.length"
            @click="addFiled"
            class="button is-right"
            type="button"
          >{{$t('index.add_selected')}}</span>
        </header>

        <section
          class="modal-card-body"
          style="max-height:350px"
        >
          <b-table
            :data="availableFields"
            :checked-rows.sync="checkedAvailableFields"
            checkable
          >
            <template slot-scope="props">
              <b-table-column
                field="name"
                :label="$t('index.name')"
                width="210"
              >
                {{props.row.name}}

              </b-table-column>
              <b-table-column
                field="name"
                :label="$t('index.type')"
                width="210"
              >
                {{props.row.type!==1?$t('index.system_field'):$t('index.custom_field')}}
                <!-- <span
                  class="tag"
                  :class='{"is-success":props.row.type===1}'
                >
                  {{props.row.type!==1?"system":"custom"}}
                </span> -->

              </b-table-column>
            </template>
          </b-table>
        </section>
      </div>

    </b-modal>

  </div>
</template>

<script>
import FDateTime from './FDateTime.vue';
const today = new Date();
var moment = require('moment-timezone');
export default {
  props: ['objectId', 'tagName', 'fields', 'roomData'],
  components: {
    FDateTime
  },
  data() {
    return {
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      validateCustomFieldError: false,
      resultFields: this.fields,
      checkedAvailableFields: [],
      columnsAvailableFields: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'type',
          label: 'Type'
        }
      ],
      availableFieldsBase: [
        {
          name: 'Configuration',
          defVal: true,
          type: 0
        },
        {
          name: 'ArrivalDateTime',
          defVal: true,
          type: 0
        },
        {
          name: 'DepartureDateTime',
          defVal: true,
          type: 0
        },
        {
          name: 'SessionTime',
          defVal: true,
          type: 0
        },
        {
          name: 'Email',
          defVal: true,
          type: 0
        },
        {
          name: 'Custom',
          defVal: true,
          type: 1
        }
      ],
      isShowAvailableFields: false,
      erroredFiedls: {}
    };
  },
  methods: {
    isEditable(name) {
      console.log(name);
      switch (name) {
        case 'Configuration':
          return true;

        default:
          return false;
      }
    },
    validateCustomType(event, id) {
      let re = /^[a-zA-Z0-9_-]*$/i;
      let duplicate = false;
      let errored = !re.test(String(event).toLowerCase());

      if (!errored) {
        duplicate = this.resultFields.filter(f => f.name === event).length > 1;
      }

      this.$set(this.erroredFiedls, id, errored || duplicate);
      this.validateCustomFieldError = false;
      for (const key in this.erroredFiedls) {
        if (this.erroredFiedls.hasOwnProperty(key)) {
          if (this.erroredFiedls[key]) {
            this.validateCustomFieldError = true;
          }
        }
      }
    },
    deleteField(row) {
      this.resultFields.splice(this.resultFields.findIndex(item => item.name === row.name), 1);
    },
    existField(field) {
      if (field.type === 1) return false;
      return this.resultFields.filter(f => f.name == field.name).length;
    },
    saveFileds() {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/tagfields/save`,
        transformResponse: [
          data => {
            return JSON.parse(data);
          }
        ],
        data: {
          tagName: this.tagName,
          objectId: this.objectId,
          fields: this.resultFields
        }
      })
        .then(response => {
          if (response.data.status) {
            this.openNotificationWithType('danger', '', response.data.error);
          } else {
            this.$parent.close();
            if (this.roomData) {
              this.$emit('create_room_fields', this.roomData);
            }
            // console.log(response.data);
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    addFiled() {
      this.checkedAvailableFields.forEach(af => {
        if (!this.existField(af)) {
          let defValue = '';
          let canEdit = true;
          let departureDate = new Date();
          departureDate.setDate(departureDate.getDate() + 7);

          switch (af.name) {
            case 'Configuration':
              defValue = this.tagName;
              canEdit = false;
              break;
            case 'Email':
            case 'ArrivalDateTime':
            case 'DepartureDateTime':
            case 'SessionTime':
              break;

            default:
              defValue = 'default value';
              break;
          }

          this.resultFields.push({
            name: af.type === 1 ? 'Custom_' + Math.floor(Date.now()) : af.name,
            type: af.type,
            value: defValue,
            edit: canEdit,
            defVal: true
          });
        }
      });

      this.isShowAvailableFields = false;
      this.checkedAvailableFields = [];
    },
    showAvailableFields() {
      if (this.availableFields.length === 1) {
        this.resultFields.push({
          name: 'Custom_' + Math.floor(Date.now()),
          type: 1,
          value: 'default value',
          edit: true,
          defVal: true
        });
      } else {
        this.isShowAvailableFields = true;
      }
    }
  },
  computed: {
    availableFields() {
      return this.availableFieldsBase.filter(f => {
        return (
          this.resultFields
            .reduce((p, c) => {
              if (c.type !== 1) {
                p.push(c.name);
              }
              return p;
            }, [])
            .indexOf(f.name) < 0
        );
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Tagfields.vue?b94a875e